import {useTolgee} from "@tolgee/react";
import {useCallback} from "react";
import {convertFromTolgeeLanguageCode} from ".";
import {GIBBERISH_DATE, DateInput, parseDate} from "./dateUtils";

export default function useFormatDate() {
  const tolgee = useTolgee(["language"]);
  const currentLanguage = tolgee.getLanguage();

  return useCallback(
    (date: DateInput | null | undefined, options?: Intl.DateTimeFormatOptions): string => {
      const parsed = parseDate(date);
      if (!parsed) return "";

      if (currentLanguage === "xx") {
        return GIBBERISH_DATE;
      }

      const locale = currentLanguage ? convertFromTolgeeLanguageCode(currentLanguage) : undefined;
      return new Intl.DateTimeFormat(locale, options).format(parsed);
    },
    [currentLanguage],
  );
}
